import moment from 'moment';

function formatPhone(value) {
  if (value) {
    let re = /\(?(\d{1})\)?(\d{3})?[- ]?(\d{3})?[- ]?(\d{2})[- ]?(\d{2})/g;
    let subst = '$1 ($2) $3-$4-$5';

    return value.replace(re, subst);
  }
}

function formatObjectKeys(object) {
  return Object.keys(object).reduce(
    (newObject, currentKey) => ({
      ...newObject,
      [currentKey
        .match(/([A-Z]?[^A-Z]*)/g)
        .slice(0, -1)
        .map(i => i[0].toLowerCase() + i.slice(1, i.length))
        .join('_')]: object[currentKey],
    }),
    {}
  );
}

function removeNullKeys(object) {
  return Object.keys(object)
    .filter(item => object[item])
    .reduce(
      (newObject, currentKey) => ({
        ...newObject,
        [currentKey]: object[currentKey],
      }),
      {}
    );
}

function formatTimestamp(timestamp) {
  let date = new Date(parseInt(timestamp));

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  day = (day < 10 ? '0' : '') + day;
  month = (month < 10 ? '0' : '') + month;

  let str = `${day}.${month}.${year}`;

  return str;
}

function dateToTimestamp(value) {
  return Date.parse(value);
}

function formatService(value) {
  let start = value.indexOf('(');
  let end = value.indexOf(')');

  return value.substring(start, end);
}

function formatServicesArr(arr) {
  arr.map(item => {
    let start = item.indexOf('(');
    let end = item.indexOf(')');

    return item.substring(start, end);
  });
}

function trimString(val, len) {
  if (val && val.length) {
    return val.length > len ? val.substring(0, len) + '...' : val;
  }
}
function vehiclesFilterRequestStr(payload) {
  let requestSet = new Set();
  let requestStr = [];

  let request = payload.map(filter => {
    for (let [key, value] of Object.entries(filter)) {
      if (value instanceof Array) {
        value.map(val => requestSet.add(`${key}[]=${val}`));
      }
      if (value instanceof moment) {
        requestSet.add(
          `${key
            .split('_')
            .slice(0, -1)
            .join('_')}[${key.split('_').slice(-1)}]=${moment(value).valueOf()}`
        );
      }
      if (typeof value === 'number') {
        requestSet.add(
          `${key
            .split('_')
            .slice(0, -1)
            .join('_')}[${key.split('_').slice(-1)}]=${value}`
        );
      }
    }
    return requestSet;
  });
  for (let item of request) {
    requestStr = Array.from(item).join('&');
  }

  return requestStr.length ? `&${requestStr}` : requestStr;
}

function formFilterRequestStr(payload) {
  let requestSet = new Set();
  let requestStr = [];

  let request = payload.map(filter => {
    for (let [key, value] of Object.entries(filter)) {
      if (value instanceof Array) {
        value.map(val => requestSet.add(`${key}[]=${val}`));
      }

      if (typeof value === 'string') {
        requestSet.add(`${key}[]=${value}`);
      }

      if (value instanceof moment) {
        if (key.includes('_from') || key.includes('_to')) {
          const keyFromTo =
            key
              .split('_')
              .slice(0, key.split('_').length - 1)
              .join('_') + `[${key.split('_')[key.split('_').length - 1]}]`;
          requestSet.add(
            `${keyFromTo}=${moment(value).format('DD-MM-YYYY HH:mm:ss')}`
          );
        } else {
          requestSet.add(`${key}[]=${value}`);
        }
      }

      if (typeof value === 'number') {
        if (key.includes('_from') || key.includes('_to')) {
          const keyFromTo =
            key
              .split('_')
              .slice(0, key.split('_').length - 1)
              .join('_') + `[${key.split('_')[key.split('_').length - 1]}]`;
          requestSet.add(`${keyFromTo}=${value}`);
        } else {
          requestSet.add(`${key}[]=${value}`);
        }
      }
    }

    return requestSet;
  });

  for (let item of request) {
    requestStr = Array.from(item).join('&');
  }

  return requestStr;
}

function formatRequestNumber(value) {
  if (value) {
    let re = /\(?(\d{3})\)?(\d{3})?[- ]?(\d{3})?[- ]?(\d{3})[- ]?(\d{3})[- ]?(\d{2})[- ]?(\d{2})/g;
    let subst = '$1 $2 $3 $4 $5 $6';

    return value.replace(re, subst);
  }
}

function getNumberWithoutSpaces(x) {
  return String(x).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

function getTimeFromString(str) {
  let time = '';
  let timeArr = str.split(':');

  timeArr.forEach((item, i) => {
    if (i === 0 && item.indexOf('00')) {
      if (item.startsWith('0') && parseInt(item) === 1) {
        time += `${item.substring(1)} час `;
      }
      if (item.startsWith('0') && parseInt(item) > 1 && parseInt(item) < 5) {
        time += `${item.substring(1)} часа `;
      }
      if (item.startsWith('0') && parseInt(item) >= 5) {
        time += `${item.substring(1)} часов `;
      }
    }
    if (i === 1 && item.indexOf('00')) {
      if (item.startsWith('0')) {
        time += `${item.substring(1)} мин`;
      }
      time += `${item} мин`;
    }
  });

  return time;
}

export {
  formatPhone,
  formatObjectKeys,
  removeNullKeys,
  formatTimestamp,
  dateToTimestamp,
  formatService,
  formatServicesArr,
  trimString,
  formFilterRequestStr,
  formatRequestNumber,
  getTimeFromString,
  getNumberWithoutSpaces,
  vehiclesFilterRequestStr,
};
